module.exports = __webpack_public_path__ + "static/media/amo1.4529e0a4.webp";